import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';

const SomeIconMap = {
  twitch: {
    color: '#673b8e',
    icon: 'twitch',
    offset: '-10%',
  },
  youtube: {
    color: '#fe0303',
    icon: 'youtube-play',
    offset: '0',
  },
  facebook: {
    color: '#3c5a99',
    icon: 'facebook',
    offset: '0',
  },
  linkedin: {
    color: '#0077b5',
    icon: 'linkedin',
    offset: 0,
  },
  twitter: {
    color: '#56aced',
    icon: 'twitter',
    offset: '0',
  },
  instagram: {
    color: '#000000',
    icon: 'instagram',
    offset: '0',
  },
  snapchat: {
    color: '#000000',
    icon: 'snapchat-ghost',
    offset: '0',
  },
  myspace: {
    color: '#000000',
    icon: '',
    offset: '0',
  },
};

const StyledBackground = styled.div`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  position: absolute;
  transform: scale(1) translate3d(0,0,0);
  transition-duration: 0.25s;
  transition-property: background-color, transform;
  transition-timing-function: ${styles.easing.inOutQuad};
`;

const StyledLink = styled.a`
  width: 4rem;
  height: 4rem;
  border-radius: 100%;
  position: relative;

  &:before {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: inherit;
    transform: scale(.9) translate3d(0,0,0);
    content: '';
    transition-duration: 0.25s;
    transition-property: transform, opacity;
    transition-timing-function: ${styles.easing.inOutQuad};
  }

  ${StyledBackground} {
    ${props => props.theme === 'plain' ? `
      border: 2px solid ${styles.color.SLATE_LIGHT};
    `: `
    ${props =>
      `
        background-color: ${SomeIconMap[props.someType].color};
      `};
    `}
  }
  ${props => props.theme === 'plain' ? `
    &:before {
      border: 6px solid ${styles.color.SLATE_LIGHT};
      opacity: 0;
    }
    i {
      color: ${styles.color.SLATE_LIGHT};
    }
  ` : `
    background: rgba(0, 0, 0, 0.125);
  `}
  .current-input-mouse &:hover,
  .current-input-touch &:active {
    &:before {
      transform: scale(1.0) translate3d(0,0,0);
    }


    ${StyledBackground} {
      transform: scale(0.9) translate3d(0,0,0);
    }

    ${props => props.theme === 'plain' ? `
      &:before {
        border: 4px solid ${styles.color.SLATE_LIGHT};
        opacity: 0.2;
      }

    ` :
    `
      ${StyledBackground} {
        background-color: ${styles.color.SLATE};
      }
    `
    }
  }

  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    position: relative;
    ${props =>
      `
        margin-bottom: ${SomeIconMap[props.someType].offset};
      `};
  }
`;

const SomeLink = props => {
  const { theme, type, link } = props;
  return (
    <StyledLink
      theme={theme}
      someType={type}
      rel="external nofollow noopener"
      href={link}
    >
      <StyledBackground />
      <i className={`fa fa-${SomeIconMap[type].icon}`} />
    </StyledLink>
  );
};

SomeLink.propTypes = {
  type: PropTypes.oneOf([
    'facebook',
    'instagram',
    'linkedin',
    'myspace',
    'snapchat',
    'twitch',
    'twitter',
    'youtube',
  ]).isRequired,
  link: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['default', 'plain']).isRequired,
};

SomeLink.defaultProps = {
  theme: 'default',
};

export default SomeLink;



// WEBPACK FOOTER //
// ./src/modules/pages/components/SomeLink.js